import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class flowState extends baseState {
  @observable list = {};
  @action
  setList = data => this.list = data;
  getList = data => {
    return this.fetch({
      url: apiUrl.SOURCE.FLOW.LIST,
      method: 'get',
      setState: this.setList,
      data,
    });
  }

  @observable detail = {};
  @action
  setDetail = data => this.detail = data;
  getDetail = (data, id) => {
    return this.fetch({
      url: apiUrl.SOURCE.FLOW.DETAIL + id,
      method: 'get',
      setState: this.setDetail,
      data,
    });
  }
}
